import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const insightsPortalDeliveryOrchestrationProviderDrilldownAccessControl: DomainAccessControlConfig =
  [
    {
      permissions: Permission.Analytics,
      featureToggles: [FeatureToggle.DeliveryOrchestration],
    },
  ]
